import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActionType, AdditionalDetailsWrapper, FocusInputType, KeyValues3, LocalService, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-edit-additional-details',
  templateUrl: './edit-additional-details.component.html',
  styleUrls: ['./edit-additional-details.component.scss']
})
export class EditAdditionalDetailsComponent implements OnInit {
  @Input() id = ''; @Input() ctryCode = ''; lstSectionConfigKeys: string[] = ["edit_additional_details", "table"]; isShowDummyHeight = false;
  wrapper: AdditionalDetailsWrapper; @Input() isPickMode = false; selectedAddress = ''; isAddNewAddress = false; editId = ''; maxBodyHeight = 0;
  isVerificationPart = false;
  elementIds: any = {
    txt_address_title: 'txt_address_title',
    dd_select_address: 'dd_select_address'
  };
  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, public profileManagementService: ProfileManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight(10);
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.isPickMode) {
      this.profileManagementService.getDeliveryAddresses(this.id).subscribe(result => {
        if (result.length > 0) {
          let item = result.find(x => x.key == this.editId);
          this.selectedAddress = item ? item.key : result[0].key;
        }
        else
          this.isAddNewAddress = true;
        this.wrapper = {
          details: { key: this.id } as KeyValues3
          , newAddress: { key: this.id, v2: '', v3: '' } as KeyValues3
          , deliveryAddress: result
        } as AdditionalDetailsWrapper;
        this.onChange();
      });
    } else {
      this.isAddNewAddress = true;
      this.profileManagementService.editAdditionalDetails(this.id, this.ctryCode).subscribe(result => {
        this.wrapper = result;
      });
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onEmailInput() {
    this.isVerificationPart = false;
  }

  onEmailVerified() {
    this.isVerificationPart = false;
    this.onPopupSave(true);
  }

  onPopupSave(isEmailConfirmed = false) {
    if (this.isPickMode) {
      if (this.isAddNewAddress) {
        this.profileManagementService.saveDeliveryAddess(this.wrapper.newAddress).subscribe(result => {
          if (result.status == Status.Success) {
            this.activeModal.close({ event: TriggeredEvent.Ok, data: result.id });
          } else if (result.status == Status.SuccessWithMoreAction) {
            this.isVerificationPart = true;
          }
        });
      } else {
        this.activeModal.close({ event: TriggeredEvent.Ok, data: this.selectedAddress });
      }
    } else {
      this.wrapper.isEmailConfirmed = isEmailConfirmed;
      this.wrapper.details.v1 = this.wrapper.details.v1.trim().toLowerCase();
      if (this.onCheck()) {
        this.profileManagementService.saveAdditionalDetails(this.id, this.ctryCode, this.wrapper).subscribe(result => {
          if (result.status == Status.Success) {
            this.activeModal.close({ event: TriggeredEvent.Ok });
          } else if (result.status == Status.SuccessWithMoreAction) {
            this.isVerificationPart = true;
          }
        });
      }
    }
  }

  onCheck(): boolean {
    let rtn = true;
    this.wrapper.newAddress.v2 = this.wrapper.newAddress.v2.trim();
    this.wrapper.newAddress.v3 = this.wrapper.newAddress.v3.trim();
    if (this.wrapper.newAddress.v2 || this.wrapper.newAddress.v3) {
      if (!this.wrapper.newAddress.v2) {
        this.localService.showInformation(this.localService.languageContent.edit_additional_details.title_req, true);
        rtn = false;
      } else if (!this.wrapper.newAddress.v3) {
        this.localService.showInformation(this.localService.languageContent.edit_additional_details.address_req, true);
        rtn = false;
      }
    }
    return rtn;
  }

  editedKey: string = '';
  onAction(index, key: string, idx?: number) {
    let item = this.wrapper.deliveryAddress.find(x => x.key == key);
    if (item) {
      switch (index) {
        case 1: {
          this.profileManagementService.onAction(key, this.ctryCode, ActionType.ActiveOrInActive).subscribe(result => {
            if (result == Status.Success) {
              this.wrapper.deliveryAddress.find(x => x.key == key).v1 = (item.v1 == "1" ? "0" : "1");
            }
          });
        } break;
        case 2: {
          this.profileManagementService.onAction(key, this.ctryCode, ActionType.Delete).subscribe(result => {
            if (result == Status.Success) {
              this.wrapper.deliveryAddress = this.wrapper.deliveryAddress.filter(x => x.key != key);
            }
          });
        } break;
        case 3: {
          this.localService.onFocusNextInput(this.elementIds.txt_address_title + '_' + (idx + 1), FocusInputType.TextBox);
          this.editedKey = key;
        } break;
        case 4: {
          const item = this.wrapper.deliveryAddress.find(x => x.key == key);
          if (item) {
            this.profileManagementService.updateDeliveryAddress(item.key, item.v2, item.v3).subscribe(result => {
              this.localService.showInformationByStatus(result.status);
              if (result.status == Status.Success) {
                this.editedKey = '';
              }
            });
          }
        } break;
        case 5: {
          this.editedKey = '';
        } break;
      }
    }
  }

  onChange() {
    if (this.isAddNewAddress)
      this.localService.onFocusNextInput(this.elementIds.txt_address_title, FocusInputType.TextBox);
    else
      this.localService.onFocusNextInput(this.elementIds.dd_select_address, FocusInputType.NgxDropDown);
  }

  showHideDummyHeight(isShow: boolean) {
    this.isShowDummyHeight = isShow;
  }
}
